import { submitData } from '@nextiva/credit-card-form';

/**
 * Parses Vantiv provider properties into a Vantiv submit data object.
 *
 * @param  vantivProps - The properties of the Vantiv provider.
 * @returns  - The parsed submit data containing the `id` and `orderId`.
 * If either `MID` or `orderId` is missing, it falls back to the default `submitData`.
 */
export const parsePropsToSubmitData = vantivProps => {
  const { MID, orderId } = vantivProps;
  return MID && orderId ? { id: MID, orderId } : submitData;
};
